import React from 'react';
import ReactDOM from 'react-dom/client';
// import { Provider } from 'react-redux';


// import { reduxStore } from 'state/store';
import App from 'app/App';


const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    {/* <Provider store={reduxStore}> */}
    
      <App />
    
    {/* </ Provider> */}
  </React.StrictMode>
);
